/**
 * SchedulingRoute — always renders the unified Scheduling & Dispatch cockpit
 * on its Plan lens. The legacy SchedulingCalendar surface is retired from
 * this URL; cockpit is canonical regardless of UI skin.
 */
import SchedulingDispatchCockpit from "@/components/dashboards/SchedulingDispatchCockpit";

export default function SchedulingRoute() {
  return <SchedulingDispatchCockpit />;
}
